export enum EnumTipoSolicitacaoTecnica {
  Interna = 1,
  Externa = 2
}